// extracted by extract-css-chunks-webpack-plugin
module.exports = {"vote":"vote-6s1tWJFv","voted":"voted-PjEK2pwZ","greyVote":"greyVote-EbABRA48","greyVoted":"greyVoted-tk7vtvuW"};